import styles from "./typo.module.scss";
export const Title = ({
  text,
  autoWidth = false,
  fontSize = "14px",
  color = "#191919",
  fontWeight = "700",
}: {
  text: string | React.ReactNode;
  autoWidth?: boolean;
  fontSize?: string;
  color?: string;
  fontWeight?: string;
}) => {
  return (
    <div
      className={styles["title"]}
      style={{
        width: autoWidth ? "auto" : "100%",
        fontSize: fontSize,
        fontWeight: fontWeight,
        color: color,
      }}
    >
      {text}
    </div>
  );
};
